export const Label = ({ label = 'Button', className = '' }) => {
  return <div className={`text-sm mt-0.5 ${className}`}>{label}</div>;
};
